import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-maintenance",
  standalone: true,
  templateUrl: "./maintenance.html",
  styleUrl: "./maintenance.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceComponent {}
